import { withAuthenticationRequired } from "@auth0/auth0-react";
import { store } from "../store";
import { useTranslation } from "react-i18next";
import { Grid, Paper, Box, Typography, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { alpha } from "@mui/material/styles";
import EstablishmentsTable from "../components/tables/Establishments";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Store, Business, FilterList } from "@mui/icons-material";

function Establishments(props) {
  const { t } = useTranslation("common");

  const userDB = useSelector((state) => state.userDB);
  const establishments = useSelector((state) => state.establishments);
  const brands = useSelector((state) => state.brands);
  const residences = useSelector((state) => state.residences);

  const [selectedBrand, setSelectedBrand] = useState("all");

  useEffect(() => {
    store.dispatch({
      type: "pageTitle/update",
      payload: t("common.establishments"),
    });

    let pageActions = [];

    if (userDB.admin) {
      pageActions = [
        {
          name: t("common.add_new", { name: "" }),
          icon: "Add",
          url: "/add/establishment",
        },
      ];
    }

    store.dispatch({ type: "pageActions/update", payload: pageActions });
  }, [t, userDB.admin]);

  // Filtrer les établissements par enseigne
  const filteredEstablishments = selectedBrand === "all"
    ? establishments
    : establishments?.filter(est => est.brand_id === selectedBrand) || [];

  // Calcul des statistiques
  const totalEstablishments = filteredEstablishments?.length || 0;

  // Compter les résidences par établissement
  const totalResidences = residences?.filter(res =>
    filteredEstablishments?.some(est => est.id === res.establishment_id)
  ).length || 0;

  const statsCards = [
    { title: t("common.total"), value: totalEstablishments, icon: Store, color: "#78a882" },
    { title: t("common.residences"), value: totalResidences, icon: Business, color: "#6b9dad" },
  ];

  return (
    <Grid container spacing={2}>
      {/* Cartes KPI */}
      <Grid item xs={12}>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2 }}>
          {statsCards.map((card, index) => (
            <Paper
              key={index}
              sx={{
                p: 2,
                flex: "1 1 200px",
                minWidth: 200,
                background: alpha(card.color, 0.15),
                borderLeft: `4px solid ${card.color}`,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <card.icon sx={{ color: card.color, fontSize: 32 }} />
                <Box>
                  <Typography variant="h4" sx={{ color: card.color, fontWeight: "bold" }}>
                    {card.value}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {card.title}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>
      </Grid>

      {/* Filtre par enseigne */}
      <Grid item xs={12}>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FilterList sx={{ color: "#78a882" }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              {t("common.title_filters")}
            </Typography>
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>{t("common.brand")}</InputLabel>
              <Select
                value={selectedBrand}
                label={t("common.brand")}
                onChange={(e) => setSelectedBrand(e.target.value)}
              >
                <MenuItem value="all">{t("common.all")}</MenuItem>
                {brands?.map((brand) => (
                  <MenuItem key={brand.id} value={brand.id}>
                    {brand.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Paper>
      </Grid>

      {/* Tableau */}
      <Grid item xs={12}>
        <EstablishmentsTable filteredEstablishments={filteredEstablishments} />
      </Grid>
    </Grid>
  );
}

export default withAuthenticationRequired(Establishments);
